import React, { useEffect } from 'react';
import FormField from '../../FormField';
import MultiSelectDropDown from 'reusableComponents/multipleDropdown';
import { FormFieldProps } from '../../FormTypes';
import { ProviderSelection } from '../../../JobRequestTypes';
import { useJobFormContext } from '../../../JobFormContext';
import { Text } from 'library';

interface PastProvidersInputProps {
    pastProviders: FormFieldProps<ProviderSelection[]>;
}

export default function PastProvidersInput({ pastProviders }: PastProvidersInputProps) {
    const { pastProviders: values } = useJobFormContext();

    useEffect(() => {
        pastProviders.setValid(pastProviders.value.length > 0);
    }, [pastProviders.value]);

    function onChange(event: { target: { value: number[] } }) {
        const newProviderIds = event.target.value;
        const newProviders = values.filter((choice) => newProviderIds.includes(choice.id));

        pastProviders.setValue(newProviders);
    }

    return (
        <>
            <div style={{ marginTop: 15 }} />
            <Text variant="h2" bold>
                Past Providers*
            </Text>
            <FormField>
                <MultiSelectDropDown
                    helperText="Select who this job is for"
                    selected={toIds(pastProviders.value)}
                    fields={values}
                    onChange={onChange}
                />
            </FormField>
        </>
    );
}

function toIds(providers: ProviderSelection[]) {
    return providers.map((provider) => provider.id);
}
